import {
  isBenefitAlwaysAdditional,
  isBenefitHidden,
  isBenefitIncludedInSubscriptionLevel,
  sortCMSBenefits
} from "../utils";
import { IWebflowBenefitCategory } from "@wingspanhq/cms/dist/lib/interfaces/webflow/benefits";
import { ISubscription } from "@wingspanhq/users/dist/lib/interfaces/subscription";
import { FeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { getMeridioHealthInsuranceBenefit } from "../components/customBenefits/Meridio/getMeridioHealthInsuranceBenefit";
import { ExtendedWebflowBenefit } from "../types";
import { getPGLIBenefitListItem } from "../components/customBenefits/PGLI/getPGLIBenefitListItem";
import { getOAIBenefitListItem } from "../components/customBenefits/OAI/getOAIBenefitListItem";

const ASSURELY_REDIRECT_URL = "https://get.equalparts.ai/";

const METLIFE_DENTAL_URL =
  "https://www.metlifetakealongdental.com/?ReferralCode=Wingspan";

export const customizeBenefit = (benefit: ExtendedWebflowBenefit) => {
  // mark as isAssurely https://linear.app/wingspan/issue/PLA-1150/insurance-move-assurely-business-insurance-to-the-independent
  if (benefit.slug === "assurely-business-insurance") {
    return {
      ...benefit,
      customEnrollLink: ASSURELY_REDIRECT_URL,
      orderPriority: 99, // should be the last one
      isAssurely: true
    };
  }

  // https://linear.app/wingspan/issue/PLA-2147/fix-dental-insurance-something-may-have-happened
  if (benefit.slug === "dental-insurance") {
    return {
      ...benefit,
      helperHideMemberAndGroupInfo: true,
      helperCostIsNotIncluded: true,
      helperCostDescription: "Varied",
      helperCTAPrimaryButtonLink: METLIFE_DENTAL_URL,
      helperCTAPrimaryButtonText: "Get started"
    };
  }

  return benefit;
};

export const selectorBenefitsList = (params: {
  list: ExtendedWebflowBenefit[];
  userId: string;
  enterpriseId?: string;
  categories?: IWebflowBenefitCategory[];
  isAdditional?: boolean;
  subscription: ISubscription | undefined;
  featureFlag: FeatureFlags;
  showMasterPolicyEnrollment: boolean;
}): ExtendedWebflowBenefit[] => {
  const insurances = [
    params.featureFlag.meridio ? getMeridioHealthInsuranceBenefit() : null,
    params.showMasterPolicyEnrollment ? getOAIBenefitListItem() : null,
    params.showMasterPolicyEnrollment ? getPGLIBenefitListItem() : null
  ].filter(Boolean) as ExtendedWebflowBenefit[];

  const allBenefits = [...params.list, ...insurances];

  return allBenefits
    .filter(
      benefit =>
        !isBenefitHidden(benefit) &&
        (params.isAdditional
          ? isBenefitAlwaysAdditional(benefit) ||
            !isBenefitIncludedInSubscriptionLevel(benefit, params.subscription)
          : isBenefitIncludedInSubscriptionLevel(benefit, params.subscription))
    )
    .filter(benefit =>
      params.categories ? params.categories.includes(benefit.category) : true
    )
    .filter(
      benefit =>
        // TODO: should we implement it in cms?
        // Don't display Life insurance for "finfit" company https://linear.app/wingspan/issue/WIN-4075
        !(
          benefit.slug === "life-insurance" &&
          (params.enterpriseId === "finfit" ||
            params.userId === "SIRR90o4HHL04a_qsXRXkV")
        )
    )
    .map(customizeBenefit)
    .sort((a, b) => sortCMSBenefits(a, b));
};
